import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 12h2","key":"svg-0"}],["path",{"d":"M20 12h2","key":"svg-1"}],["path",{"d":"M4 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M16 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}],["path",{"d":"M7.5 10.5l7.5 -5.5","key":"svg-4"}]]

const IconCircuitSwitchOpen = createReactComponent('outline', 'circuit-switch-open', 'CircuitSwitchOpen', __iconNode);

export default IconCircuitSwitchOpen;